import React from "react";
import { GridToolbarQuickFilter } from "@mui/x-data-grid";
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment } from "@mui/material";
import { useTranslation } from "react-i18next";

const CustomGridToolbarQuickFilter = ({ onChange, fullWidth, ...props }) => {
  const { t } = useTranslation();

  return (
    <GridToolbarQuickFilter
      {...props}
      placeholder={t("common.search")}
      variant="outlined"
      size="small"
      quickFilterParser={(searchInput) => [searchInput]}
      onQuickFilterChange={(values) => {
        // values là mảng string
        onChange?.(values?.[0] || "");
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon fontSize="small" sx={{ color: "#D0D5DD" }} />
          </InputAdornment>
        ),
      }}
      sx={{
        width: fullWidth ? "100%" : "auto",
        "& .MuiInputBase-root": {
          borderRadius: "8px",
          backgroundColor: "#FEFEFE",
          height: "40px",
          width: fullWidth ? "100%" : "235px", // 👈 key ở đây
          maxWidth: fullWidth ? "100%" : "235px",
          marginTop: "5px",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderColor: "#D0D5DD",
        },
        "&:hover .MuiOutlinedInput-notchedOutline": {
          borderColor: "#D0D5DD",
        },
        "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
          borderColor: "#D0D5DD",
        },
        "& .MuiInputBase-input::placeholder": {
          color: "#000000",
        },
      }}
    />
  );
};

export default CustomGridToolbarQuickFilter;
